import { ApiGender, ApiItemType } from '@ibe/api';
import ConfigModel, { NoteLevelsType } from './ConfigModel';
import HotelRoomView from './HotelRoomView';

const defaultConfig: ConfigModel = {
  defaultLanguage: 'en',
  apiUrl: '/',
  configUrl: '/config.json',
  translationsUrl: '',
  sessionKeyTabsShared: true,
  sessionKeyAuth: 'IBE_AUTH',
  sessionKeyApp: 'IBE_APP',
  sessionKeyCart: 'IBE_CART',
  sessionKeyPackageCart: 'IBE_PACKAGE_CART',
  sessionKeyCookieLaw: 'IBE_COOKIES',
  sessionKeyCurrency: 'IBE_CURRENCY',
  sessionKeyDiscardedRecommendations: 'IBE_DISCARDED_RECOMMENDATIONS',
  sessionKeySearchParams: 'IBE_SEARCH_PARAMS',
  formatDate: 'YYYY-MM-DD',
  formatTime: 'HH:mm',
  datePickerMinDateOffset: 1,
  roomsLeftMaxToDisplay: 5,
  offersLeftMaxToDisplay: 5,
  displayFormatDate: {
    de_DE: 'DD.MM.YYYY',
    en_US: 'MM/DD/YYYY'
  },
  displayFormatDateShort: {
    de_DE: 'DD. MMM',
    en_US: 'DD MMM'
  },
  displayFormatDateTime: {
    de_DE: 'DD.MM.YYYY HH:mm',
    en_US: 'MM/DD/YYYY HH:mm'
  },
  displayFormatWeekDay: {
    de_DE: 'ddd, DD.MM.YYYY',
    en_US: 'ddd, MM/DD/YYYY'
  },
  googleApiKey: '', // ISO IBE test account, see wiki.
  googleReCaptchaKey: '6Lc3LOIZAAAAAJvtC3EtvkE0P_hNvkRQjkjSRGgW',
  googleAnalyticsTrackingId: null,
  googleTagManagerContainerId: null,
  useIndexedGeoUnits: false,
  useConsentManager: false,
  pageToRoute: {
    [ApiItemType.HOTEL]: {
      page: ''
    }
  },
  defaultCurrency: 'EUR',
  currency: 'EUR',
  session: {
    expirationTimeNotificationOffset: 5,
    expirationTime: 5
  },
  serviceCharacteristics: {
    [ApiItemType.EXTRA]: {
      language: 'LANGUAGE',
      exertionLevel: 'EXERTION_LEVEL'
    },
    [ApiItemType.HOTEL]: {
      amenities: 'AMENITIES',
      facilities: 'FACILITIES'
    }
  },
  unitOptions: {
    noSelection: 'NOMEAL',
    showTAC: false
  },
  theme: null,
  traveler: {
    genderValues: Object.values(ApiGender),
    maxChildAge: 17,
    maxChildAgeFlightSearch: 17,
    maxInfantAge: 2,
    mockAvailable: true,
    treatInfantsAsChildren: false
  },
  headerScrollOffset: {
    mobile: 0,
    tablet: 0,
    desktop: 0
  },
  scrollDuration: 500,
  components: {
    voucherBuyerForm: {
      showFiscalCode: false,
      showState: true
    },
    voucherPaymentSection: {
      showTaxes: false
    },
    hotelRoomView: HotelRoomView.GROUPEDBYROOMCONFIG
  },
  scrollOffsets: {
    header: 0
  },
  externalParam: {
    delimiter: '|'
  },

  tracking: {
    hotjar: {
      hjid: null,
      hjsv: null
    }
  },
  exactSearchDurationOptions: {
    WEEKS: [1, 2, 3, 4],
    NIGHTS: [...Array.from({ length: 28 }, (_, i) => i + 1).filter(i => i > 2)]
  },
  packageSearchDurationOptions: {
    WEEKS: [1, 2, 3, 4],
    NIGHTS: [...Array.from({ length: 28 }, (_, i) => i + 1).filter(i => i > 2)]
  },
  stickySearchOffsetClass: '',
  forms: {
    excludeSalutations: [],
    showConfirmEmailField: true
  },
  roundPricesToWholeNumber: undefined,
  summaryComponentParams: {
    packageItemType: {
      showTitle: true,
      filterNote: true
    }
  },
  useTid: true,
  tenant: null,
  affiliate: null,
  noteSortingOrder: [NoteLevelsType.GLOBAL, NoteLevelsType.SERVICE, NoteLevelsType.UNIT],
  calendar: {
    weekStartsOn: {
      en: 1 /* Monday */
    }
  },
  modalContainerClass: 'its',
  payment: {
    messagingEnabled: true
  },
  paxRoomConfig: {
    minAdults: 1,
    maxAdults: 10,
    maxChildren: 10,
    maxChildAge: 17,
    maxCapacity: 9,
    maxRooms: 9
  },
  sanitizeConfig: {
    allowIframes: false
  }
};
export default defaultConfig;
